import { Component, Input, Output, EventEmitter, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
})
export class EditorComponent implements OnInit {

  @Input() data: string = '';
  @Input() config: any;
  @Output() sendClick = new EventEmitter();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadCKEditor();
    }
  }

  loadCKEditor() {
    const editorElement = document.querySelector('#editor');
    if (editorElement instanceof HTMLElement) {
      import('@ckeditor/ckeditor5-build-classic').then(ClassicEditor => {
        ClassicEditor.default
          .create(editorElement, this.config)
          .then(editor => {
            editor.setData(this.data);
            editor.model.document.on('change', () => {
              this.sendClick.emit(editor.getData());
            });
          })
          .catch(error => {
            console.error(error);
          });
      });
    }else {
      console.error("Editor element not found in the DOM");
    }

  }
}